module.exports = __webpack_public_path__ + "static/progressmates_logo-7350392f371e49f30ed8d137f59325be.png";